/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusCreateNotizDto } from '../../models/lexplus-create-notiz-dto';
import { LexplusSuccessDto } from '../../models/lexplus-success-dto';

export interface IndividuelleAnforderungDetailControllerCreateIndividuelleAnforderungNotizV1$Params {
  individuelleAnforderungID: string;
      body: LexplusCreateNotizDto
}

export function individuelleAnforderungDetailControllerCreateIndividuelleAnforderungNotizV1(http: HttpClient, rootUrl: string, params: IndividuelleAnforderungDetailControllerCreateIndividuelleAnforderungNotizV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusSuccessDto>> {
  const rb = new RequestBuilder(rootUrl, individuelleAnforderungDetailControllerCreateIndividuelleAnforderungNotizV1.PATH, 'post');
  if (params) {
    rb.path('individuelleAnforderungID', params.individuelleAnforderungID, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusSuccessDto>;
    })
  );
}

individuelleAnforderungDetailControllerCreateIndividuelleAnforderungNotizV1.PATH = '/v1/compliance/firmeninterne-anforderungen/{individuelleAnforderungID}/notizen';
